import { Routes, Route } from "react-router-dom";
import SailingSchedules from "./SailingSchedules";
import SailingScheduleCreate from "./SailingScheduleCreate";

const index = () => {
	return (
		<Routes>
			<Route index element={<SailingSchedules />} />
			<Route path='/create' element={<SailingScheduleCreate />} />
		</Routes>
	);
};

export default index;
